var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-message-to-target-action"},[_c('send-message-actions-warning'),_c('a-alert',{staticClass:"mt-1",attrs:{"description":_vm.$t('send_message_to_target_action_alert')}}),_c('action-chance',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('action-text',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('text-input',{attrs:{"setup":{
      'func': _vm.triggerInputSetupFn,
      'args': {
        model: _vm.model,
        disabled: _vm.disabled,
        'key': 'target',
        'prefix': 'trigger_action_',
        'validation': 'required',
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }